export class Porto {
    codigo: number;
    descricao: string;
    municipio: string;
    uF: string;
}